import { makeStyles } from '@material-ui/styles';

export const makeAnnouncementStyles = makeStyles({
    container: {
        color: '#FF0000',
        fontSize: '18px',
        border: '1px solid #FF0000',
        marginBottom: '16px',
        marginTop: '30px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    text: {
        padding: '13px',
        textAlign: 'center',
    },
}, { index: 1, });
